import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Action, View } from '../../../../../shared/store/view/types';
import { Glossary } from '../../../../../shared/store/glossary/types';
import { ViewService } from '../../../../../shared/store/view/views.service';
import { SubHeaderService } from '../../../../../shared/store/subheader/subheader.service';
import { GlossaryService } from '../../../../../shared/store/glossary/glossary.service';
import { environment } from '../../../../../../environments/environment';

@Component({
    selector: 'app-custom-actions-flow-glossary',
    templateUrl: './custom-actions-flow-glossary.component.html',
    styleUrls: ['./custom-actions-flow-glossary.component.scss'],
    standalone: false
})
export class CustomActionsFlowGlossaryComponent implements OnInit {
  view$: Observable<View>;
  customActions$: Observable<Action[]>;
  glossary$: Observable<Glossary>;
  comparanooUrl: string;

  constructor(
    private readonly viewService: ViewService,
    private readonly subHeaderService: SubHeaderService,
    private readonly glossaryService: GlossaryService,
  ) {}

  ngOnInit(): void {
    this.view$ = this.viewService.getViews.value$;
    this.glossary$ = this.glossaryService.getById.value$;

    this.comparanooUrl = environment.comparanoourl;
  }
  triggerAction(actionName) {
    this.subHeaderService.setTriggerAction(actionName);
  }
}
